import LandingPage, { type LandingPageContent } from '../LandingPage';

const content: LandingPageContent = {
  eyebrow: 'Luxe Property Rescue',
  headline: 'No Pressure. No Panic. Just a Plan That Makes Sense.',
  subhead:
    'When life shifts faster than you can keep up, you don\'t need another agent. You need clarity, strategy, and someone who actually gives a damn.',
  truth:
    'Selling a high-end home during a life crisis isn\'t glamorous.\nIt\'s emotional, confusing, and half the time, you don\'t even know where to start.\n\nThat\'s where Luxe Property Rescue steps in — not with hype, but with calm.\nWe handle every detail so you can focus on what matters next.',
  clarityPoints: [
    'Coordinate every move — packing, storage, and moving costs handled from escrow.',
    'Line up multiple cash offers from serious buyers in days.',
    'Renovate strategically with no out-of-pocket costs.',
    'Handle legal questions before they turn into panic.',
    'Keep you updated through a private digital portal — no chasing, no guessing.',
  ],
  calm:
    'You don\'t need perfect timing. You just need the right plan.\n\nWhen you\'re ready, we\'re here — with truth, options, and a clear path forward.',
  ctaText: 'Get My Free Strategy Report',
  pullQuote: 'We don\'t push. We plan. We don\'t promise the moon. We deliver what matters.',
  utmSource: 'sell-general',
};

export default function SellPage() {
  return <LandingPage content={content} />;
}
